import { render, staticRenderFns } from "./tongueSquareL.vue?vue&type=template&id=195ee7de&"
import script from "./tongueSquareL.vue?vue&type=script&lang=js&"
export * from "./tongueSquareL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports